export default __webpack_public_path__ + "static/media/producto-24.5619731f.jpeg";